import './Proposta.css';
import { useNavigate } from 'react-router-dom'
import { useState } from 'react';
import BannerHomePhone from '../../Banners/BannerHomePhone/BannerHomePhone.js'
import Button from '../../Button/button';
import iconeWhatsapp from '../../../imgs/whatsapp.png'

function Proposta() {
    const navigate = useNavigate();
    const [isChecked, setIsChecked] = useState(true)
    const nomeUsuario = sessionStorage.getItem("nomeUsuario")

    return (
        <div className="home">
            <div className='backgroundLateral'></div>
            <div>
                <div className='informacoesAguarde2'>
                    <div className='informacoes_recebidas2'>{nomeUsuario != null ? nomeUsuario + ", vimos": "vimos"} que você já tem uma proposta em andamento.</div>
                    <h3 className='informacoesH4'>Ela expira em <b>24 horas</b>, se nesse tempo, o valor não tenha caído em sua conta, retorne para uma nova simulação.</h3>
                    <div className='cb'></div>
                </div>
            </div>
            <div className='backgroundLateral'></div>
        </div>
    );
}

export default Proposta;